// RoleSelectionModal.js
import React from "react";
import "./RoleSelectionModal.css";

const RoleSelectionModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleRoleSelect = (role) => {
    const urls = {
      Practitioner: "https://practitioner.virtualtriage.ai/",
      Patient: "https://patient.virtualtriage.ai/",
    };
    window.location.href = urls[role];
  };

  return (
    <div className="role-modal-overlay">
      <div className="role-modal-content">
        <h2>Select Your Account Type</h2>
        <p>Please select whether you're a Practitioner or Patient.</p>
        <div className="role-buttons">
          <button
            className="role-btn practitioner"
            onClick={() => handleRoleSelect("Practitioner")}
          >
            Practitioner
          </button>
          <button
            className="role-btn patient"
            onClick={() => handleRoleSelect("Patient")}
          >
            Patient
          </button>
        </div>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default RoleSelectionModal;
